module.exports = __webpack_public_path__ + "static/media/sword.5f5a139b.png";